module.exports = __webpack_public_path__ + "static/media/image7.d39e96b2.jpg";